<div [class.disabled]="disabled">
  <mat-pseudo-checkbox class="vitamui-checkbox" [state]="selected ? 'checked' : 'unchecked'"></mat-pseudo-checkbox>
  <div><ng-content></ng-content></div>
</div>
